<template>
  <div class="calendar-entry-sidebar" v-on-clickaway="onClickAway">
    <b-sidebar position="absolute" :right="true" :fullheight="true" :overlay="false" :open="open">
      <div class="sidebar-contents" v-if="!showReplacementView">
        <calendar-entry-form v-model="editing" v-on:onChange="onChange($event)" v-on:onRequestSplit="onRequestSplit($event)" v-on:onRequestReplacement="onRequestReplacement($event)" v-on:onRequestReplacementRemove="onRequestReplacementRemove($event)" v-on:onViewReplacement="onViewReplacement($event)" :readonly="readOnlyForm" class="p-3"></calendar-entry-form>
        <div class="sidebar-footer" v-if="isVisible">
          <div class="sidebar-controls p-3 mb-0">
            <div class="control-update">
              <b-button @click="onUpdate" v-if="!isReplacement || isOwnEntry" class="is-blue">Opdater</b-button>
            </div>
            <div class="control-cancel">
              <b-button @click="onCancel" class="is-text">Annuller</b-button>
            </div>
            <div class="control-space"></div>
            <div class="control-delete">
              <b-button @click="onDelete" v-if="!isReplacement || isOwnEntryValidForDeleting" class="is-text">Slet</b-button>
            </div>
          </div>
          <div class="content p-2 updated has-text-centered">
            {{ latestUpdateText }}
          </div>
        </div>
      </div>

      <div class="sidebar-contents" v-if="showReplacementView">
        <div class="calendar-entry-form" style="padding: 0.75rem !important;">
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-header">
              Afløsere
            </div>
          </div>
          <div v-for="(replacement, index) of replacements" :key="index">
            <div class="calendar-entry-sidebar-field">
              <div class="sidebar-field-label">{{ replacement.number }}</div>
              <div class="sidebar-field-input">
                <b-input v-model="replacement.name" expanded :disabled="true" />
              </div>
            </div>
          </div>
        </div>
        <div class="sidebar-footer" v-if="isVisible">
          <div class="sidebar-controls p-3 mb-0">
            <div class="control-space"></div>
            <div class="control-cancel">
              <b-button @click="onViewReplacement" class="is-text">Annuller</b-button>
            </div>
            <div class="control-space"></div>
          </div>
          <div class="content p-2 updated has-text-centered">
            {{ latestUpdateText }}
          </div>
        </div>
      </div>
    </b-sidebar>
    <confirmation-modal></confirmation-modal>
  </div>
</template>

<script>
  import moment from "moment";
  import { mapActions, mapGetters } from "vuex";
  import CalendarEntryForm from "./EntryForm.vue";
  import ConfirmationModal from "../calendar/ConfirmationModal.vue";
  import { mixin as clickaway } from "vue-clickaway";
  import UPDATESTATE from "@/enums/UPDATESTATE";
  import _ from "lodash";

  export default {
    name: "calendar-entry-sidebar",
    mixins: [clickaway],
    components: { CalendarEntryForm, ConfirmationModal },
    props: {
      value: Object,
    },
    data: () => ({
      editing: {},
      isLoaded: false,
      allowClose: false,
      showReplacementView: false,
      ...mapActions("confirmationModalStore", ["errorModalHeader"]),
    }),
    mounted() {
      this.editing = { ...this.value };
    },
    methods: {
      ...mapActions("notificationStore", ["createNotification", "deleteNotification", "getNotificationFromAllocation"]),
      ...mapActions("allocations", ["splitAllocation"]),
      ...mapActions("entrySidebar", ["entrySidebarUpdate", "entrySidebarCancel", "entrySidebarDelete", "entrySidebarViewUpdate", "entrySidebarSplit"]),
      ...mapActions("confirmationModalStore", ["setErrorModalText", "setErrorModalOpen", "setConfirmationButtonText", "setErrorModalHeader", "setModel", "setConfirmed"]),
      onCancel() {
        this.$emit("cancel");
        this.entrySidebarCancel();
      },
      onUpdate() {
        this.$emit("entry-update", this.editing);
        this.entrySidebarUpdate(this.editing);
      },
      onDelete() {
        this.$emit("entry-delete", this.value);
        this.entrySidebarDelete();
      },
      onChange(arg) {
        if (arg && arg.id) {
          this.editing = arg;
          this.entrySidebarViewUpdate(this.editing);
        } else {
          this.onCancel();
        }
      },
      async onRequestSplit(arg) {
        this.editing = arg;
        await this.splitAllocation(this.editing);
        //this.entrySidebarNotification(this.editing);
        this.$emit("entry-update", this.editing);
        this.entrySidebarSplit();
        this.$emit("cancel");
        this.entrySidebarCancel();
      },
      async onRequestReplacement(arg) {
        arg.updateState = UPDATESTATE.RequestReplacement;
        this.editing = arg;
        const isCreated = await this.createNotification(this.editing);
        if (!isCreated) {
          this.openModal(arg);
        } else {
          //this.entrySidebarNotification(this.editing);
          this.$emit("entry-update", this.editing);
          this.entrySidebarUpdate(this.editing);
          this.$emit("cancel");
          this.entrySidebarCancel();
        }
      },
      onRequestReplacementRemove(arg) {
        this.deleteNotification(arg);
        this.$emit("entry-update", this.editing);
        this.entrySidebarUpdate(this.editing);
        this.$emit("cancel");
        this.entrySidebarCancel();
      },
      onViewReplacement(arg) {
        this.showReplacementView = !this.showReplacementView;
      },
      onClickAway() {
        if (this.allowClose && this.open) {
          this.$emit("cancel");
          this.entrySidebarCancel();
        }
      },
      openModal(model) {
        this.setModel(model);
        this.setErrorModalText("Anmodning af afløser blev ikke gennemført");
        this.setConfirmationButtonText("Prøv igen");
        this.setErrorModalHeader("Fejl ved anmodning");
        this.setErrorModalOpen(true);
      },
      delayClose: _.debounce(function() {
        this.allowClose = true;
      }),
    },
    computed: {
      ...mapGetters(["currentUser", "isReplacement", "hasEditRights"]),
      ...mapGetters("employees", ["replacementsForDate", "replacementsForDateApiState"]),
      ...mapGetters("confirmationModalStore", ["confirmed", "confirmingModel"]),
      open() {
        return this.value !== undefined;
      },
      isVisible() {
        let show = this.hasEditRights;
        if (this.editing) {
          show &= this.editing.isReadOnly === false;
        }
        return show;
      },
      isOwnEntry() {
        return this.editing.employeeId === this.currentUser.id;
      },
      isOwnEntryValidForDeleting() {
        var a = moment(this.editing.startDate);
        var b = moment(new Date());
        const totalDays = a.diff(b, "days") + 1;
        return this.isOwnEntry && totalDays > 30;
      },
      latestUpdateText() {
        const duration = moment().diff(moment(this.editing._LatestUpdate), "milliseconds");
        const durationText = duration > 0 ? moment.duration(duration).humanize() : "";

        return `Opdateret d. ${moment(this.editing._LatestUpdate).format("DD.MM.yyyy HH:mm")} af ${this.editing?._UpdatedByName}`;
      },
      readOnlyForm() {
        // Disable form for child-allocations
        if (this.value?.parentAllocationId !== "00000000-0000-0000-0000-000000000000") {
          return true;
        }
        return this.isReplacement || this.editing.isReadOnly || this.editing.allocationType === "OFFDAYREPLACEMENT" || this.hasEditRights === false;
      },
      replacements() {
        if (this.replacementsForDate) {
          let result = this.replacementsForDate.filter((o) => o.id === this.editing.replacementId || (o.replacements?.some((r) => r.circle?.groupId === this.editing.circle?.groupId) && o.replacements.filter((r) => r.circle?.groupId === this.editing.circle?.groupId).length < 2) || (!o.allocation && (this.editing.region === o.region || o.region === "begge")));
          if (this.canGroupReplace) {
            for (let item of this.availableEmployees.filter((o) => o.isActive)) {
              result.push(item);
            }
          }

          return result;
        }
        return this.replacementsForDate;
      },
      canGroupReplace() {
        return (
          this.editing.allocationType === "SICKDAY" ||
          this.editing.allocationType === "SICKDAYCHILD" ||
          this.editing.allocationType === "SICKDAYWORK" ||
          this.editing.allocationType === "MATERNETY" ||
          this.editing.allocationType === "MATERNETYNONPAID" ||
          this.editing.allocationType === "TIMEOFF" ||
          this.editing.allocationType === "FUNERAL" ||
          this.editing.allocationType === "VACATION" ||
          this.editing.allocationType === "ABSENCE"
        );
      },
    },
    watch: {
      value(newValue) {
        this.allowClose = false;
        this.showReplacementView = false;
        this.editing = { ...newValue };
        this.delayClose();
      },
      confirmed(newValue) {
        if (this.errorModalText === "Anmodning af afløser blev ikke gennemført") {
          this.setConfirmed(undefined);
          this.setErrorModalOpen(false);
          if (newValue) {
            this.onRequestReplacement(this.confirmingModel);
          }
        }
      },
    },
  };
</script>

<style lang="scss">
  .sidebar-content {
    border: 3px solid $border;

    .sidebar-contents {
      display: flex;
      flex-flow: column nowrap;
      height: 100%;
      width: 100%;

      .sidebar-spacer {
        flex: 1 1 auto;
      }
      .sidebar-footer {
        flex: 0 1 auto;
        width: 100%;

        .updated {
          background-color: $border;
          font-size: 12px;
        }
      }
    }
  }

  @media only screen and (max-width: 450px) {
    .sidebar-content {
      width: 300px !important;
      .sidebar-contents {
        .sidebar-footer {
          .updated {
            font-size: small;
          }
        }
      }
    }
  }

  .sidebar-controls {
    display: grid;
    grid-template-columns: 96px 94px auto 61px;
    grid-template-rows: 40px;
    grid-template-areas: "update cancel space delete";

    .control-update {
      grid-area: update;
    }
    .control-cancel {
      grid-area: cancel;
    }
    .control-space {
      grid-area: space;
    }
    .control-delete {
      grid-area: delete;
    }
  }
</style>
